export const REDIRECT_TYPES = {
  COLLECTION: 'collection',
  BLINKIT_LINK: 'blinkit-link',
} as const

export type RedirectType = (typeof REDIRECT_TYPES)[keyof typeof REDIRECT_TYPES]

export const DESTINATION_TYPE_API_VALUES: Record<RedirectType, string> = {
  [REDIRECT_TYPES.COLLECTION]: 'DESTINATION_TYPE_COLLECTION',
  [REDIRECT_TYPES.BLINKIT_LINK]: 'DESTINATION_TYPE_URL',
}

// A Blinkit link is a web URL on blinkit.com or an app deeplink; these lists match the backend.
export const BLINKIT_DEEPLINK_SCHEME = 'grofers'
// The schemes a Blinkit link may start with; anything else is read as a link without a scheme.
export const BLINKIT_LINK_SCHEMES = ['https', 'http', BLINKIT_DEEPLINK_SCHEME]
export const BLINKIT_WEB_HOSTS = ['blinkit.com', 'www.blinkit.com']
// Short links cannot point at another short link.
export const BLINKIT_SHORT_LINK_HOSTS = ['link.blinkit.com', 'blinkit.link', 'blinkit.to', 'b8.to']
// The only app destinations the backend accepts for a campaign link.
export const BLINKIT_DEEPLINK_DESTINATIONS = [
  'collection-products',
  'pdp',
  'listing',
  'search-products',
] as const

export const NEW_CAMPAIGN_CONSTANTS = {
  PAGE_TITLE: 'Create new campaign',
  BREADCRUMB: 'New campaign',
  STEPS: {
    CAMPAIGN_DETAILS: 'Campaign details',
    LINK_CREATION: 'Link creation',
  },
  CAMPAIGN_NAME: {
    LABEL: 'Campaign Name',
    PLACEHOLDER: 'Ex: Rakhi_2026',
    INFO_TEXT: 'Must be unique — this brand cannot reuse a name, even from a disabled campaign',
    // The create API rejects longer names ("Campaign name is too long", max_allowed 50).
    MAX_LENGTH: 50,
  },
  REDIRECT_SECTION: {
    TITLE: 'Where should the links take customers?',
    SUBTITLE: 'Pick what customers see when they tap a link in this campaign',
  },
  REDIRECT_OPTIONS: [
    {
      value: REDIRECT_TYPES.COLLECTION,
      title: 'Pick/Build collection of products',
      description:
        'Create or reuse shoppable pages with hand-picked products. Ex: Summer Glow Edit, Diwali Gifting Picks',
    },
    {
      value: REDIRECT_TYPES.BLINKIT_LINK,
      title: 'Use any Blinkit link',
      description:
        'Send shoppers straight to any Blinkit App destination. Ex: product pages, layouts, Brand Stores, or deeplinks.',
    },
  ],
  BLINKIT_LINK_FIELD: {
    LABEL: 'Enter Blinkit link',
    SUBTITLE: 'Links in this campaign will open this destination directly',
    PLACEHOLDER: 'https://blinkit.com/... or grofers://pdp?...',
    // One line each: the kit helper centres its icon on the text, so a wrapped message misaligns it.
    ERRORS: {
      REQUIRED: 'Enter a Blinkit link or app deeplink',
      INVALID: 'Enter a valid blinkit.com link or grofers:// deeplink',
      DEEPLINK_HOST: 'Deeplink must open collection-products, pdp, listing or search-products',
      NOT_BLINKIT: 'Only blinkit.com links or grofers:// deeplinks are allowed',
      SHORT_LINK: "Short links can't be used. Paste the full blinkit.com link",
    },
  },
  BUTTONS: {
    BACK: 'Back',
    CANCEL: 'Cancel',
    SAVE_AND_CONTINUE: 'Save & Continue',
    SUBMIT: 'Submit',
  },
}
